// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LinkBrokenIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LinkBrokenIcon" ref={forwardedRef} {...props}>
      <path d="M5.6 5.13 3.832 2.068l1.3-.75L6.898 4.38z" />
      <path d="M12.804 4.123h-.003l-1.59 1.59-1.06-1.061 1.414-1.415a1.75 1.75 0 0 1 2.475 0l2.828 2.829a1.75 1.75 0 0 1 0 2.475l-4.242 4.242a1.75 1.75 0 0 1-2.475 0L8.737 11.37l1.06-1.06 1.584 1.583 4.604-4.585z" />
      <path d="m4.122 12.698 3.183 3.183 1.59-1.594 1.06 1.061-1.414 1.414a1.75 1.75 0 0 1-2.475 0l-2.829-2.828a1.75 1.75 0 0 1 0-2.475L7.48 7.216a1.75 1.75 0 0 1 2.475 0l1.414 1.415-1.06 1.06-1.595-1.594-4.592 4.599z" />
      <path d="m14.4 14.875 1.767 3.061-1.299.75-1.768-3.061z" />
      <path d="m18.687 15.118-3.062-1.768-.75 1.3 3.062 1.767z" />
      <path d="m1.312 5.136 3.062 1.768.75-1.299-3.062-1.768z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LinkBrokenIcon = /* @__PURE__ */ Object.assign(
  LinkBrokenIconComponent,
  { displayName: 'LinkBrokenIcon' },
);
